import styled from "styled-components";
// import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TableFooter from "@mui/material/TableFooter";

// export const TitleBody = styled.div`
//   display: flex;
//   flex-flow: column;
//   justify-content: center;
//   align-items: center;
//   font-size: 18px;
//   color: #4f4f4f;
// `;

// export const DecomentTable = styled(Table)`
//   border-radius: 5px !important ;
//   background: transparent !important;
// `;

export const DecomentTableHead = styled(TableRow)`
  background: #eaeefc !important;
  color: #002e5c !important;
`;
export const DecomentTableFooter = styled(TableFooter)`
  background: #eaeefc !important;
  color: #002e5c !important;
`;

export const DecomentTableCellHead = styled(TableCell)`
  color: #002e5c !important;
`;

export const DecomentTableBody = styled(TableBody)`
  background-color: transparent !important;
`;

export const TableTitle = styled.div`
  color: #002e5c;
  font-size: 20px;
  font-weight: bold;
  line-height: 120.023%;
  padding-bottom: 8px;
`;

export const TotalAmount = styled.div`
  color: #4f4f4f;
  font-size: 10px;
  line-height: 120.023%;
  text-align: end;
  width: 84%;
  font-size: 14px;
`;

export const TitleGroup = styled.div`
  margin-inline-end: 18px;
  font: normal normal bold 25px/39px var(--FinanceTitleGroupFont-family);
  color: #6699ff;
  font-size: 18px;
  @media screen and (max-width: 767px) {
    font-size: 13px;
    margin-inline-end: 10px;
    text-overflow: ellipsis;
  }
`;

export const TitleTotalSpace = styled.div`
  margin-inline-end: 18px;
  font: normal normal bold 25px/39px var(--FinanceTitleTotalSpaceFont-family);
  color: #6699ff;
  font-size: 18px;
  @media screen and (max-width: 767px) {
    font-size: 13px;
    margin-inline-end: 10px;
    text-overflow: ellipsis;
    line-height: 0;
  }
`;

export const Body = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
`;
export const TitleGroupBody = styled.div`
  display: flex;
  width: 100%;
  cursor: pointer;
  margin-bottom: 15px;
  align-items: center;
`;

export const GroupCard = styled.div`
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #dfe1e5;
  border-radius: 5px;
  user-select: none;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 24px;
  color: #22224a;
  margin-top: 12px;
  font-size: 25px;
  font-weight: bold;
  background-origin: content-box;
  flex-direction: column;
  overflow: hidden;
  @media screen and (max-width: 767px) {
    padding: 15px;
  }
`;

export const Table = styled.table`
  transition: min-height 0.2s ease;
  width: 100%;
`;

export const Thead = styled.div`
  display: flex;
  overflow: hidden;
  background: #eaeefc;
  font-size: 18px;
  height: 50px;
  width: 100%;
  border-radius: 5px;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  text-align: center;
  padding: 0 25px;
  & > div {
    overflow: hidden;
    text-align: center;
    ${({ nums }) => `width: calc(100% / ${nums}) ;`}
  }
  @media screen and (max-width: 767px) {
    padding: 0 15px;
    font-size: 13px;
  }
`;
export const Col = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: start;
  align-items: center;
  color: #002e5c;
  font-size: 15px;
  font-weight: 600;
  @media screen and (max-width: 767px) {
    font-size: 15px;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  flex-grow: 1;
  text-align: center;
  width: 100%;
  padding: 20px 25px;
  cursor: pointer;
  & > div {
    ${({ nums }) => ` width: calc(100% / ${nums}) ;`}
  }
  @media screen and (max-width: 767px) {
    padding: 12px 15px;
  }
`;

export const ParcelBody = styled.div`
  cursor: pointer;
  flex-grow: 1;
  font-size: 22px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: start;
  @media screen and (max-width: 767px) {
    font-size: 13px;
  }
`;
export const Tbody = styled.div`
  font-size: 18px;
  font-weight: 300;
  & > div:not(:last-child) {
    border-bottom: 1.5px solid #dfe1e5;
  }
  @media screen and (max-width: 767px) {
    font-size: 16px;
  }
`;

export const RowCol = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: start;
  align-items: center;
  color: #4f4f4f;
  font-size: 15px;
  font-weight: 400;
  @media screen and (max-width: 767px) {
    font-size: 13px;
  }
`;

// export const DropdownControlerStyled = styled(DropdownControler)`
//   border: 0;
//   background-color: #f7f7f7 !important;
// `;

// export const InfiniteScrollStyled = styled(InfiniteScroll)``;

export const LoaderBody = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
`;

export const LoaderTitle = styled.span`
  direction: ltr;
  color: #707070;
  margin-inline-end: 13px;
`;

export const NoData = styled.div`
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #22224a;
  font-size: 23px;
  font-weight: 600;
  margin-top: 10px;
  visibility: ${(props) => (props.loading ? "hidden" : "visible")};
`;

export const MergeButton = styled.button`
  border: 1px solid #6699ff;
  border-radius: 5px;
  /* background-color: #ffffff; */
  width: 98px;
  height: 35px;
  outline: none;
  margin-inline-start: auto;
  color: #6699ff;
  font-size: 16px;
  background-color: #ffffff;
  color: #6699ff;
  @media screen and (max-width: 767px) {
    font-size: 10px;
  }
`;

export const MergeWithButton = styled.button`
  border: 1px solid #6699ff;
  border-radius: 5px;
  width: 98px;
  height: 35px;
  outline: none;
  margin-inline-start: auto;
  color: #ffffff;
  font-size: 16px;
  background-color: #6699ff;
  &:disabled {
    background-color: #707070;
    border-color: #707070;
    cursor: not-allowed;
    &:hover {
      box-shadow: none;
    }
  }
`;

export const CanceleMergeButton = styled(MergeButton)``;

export const UnmergeButton = styled.button`
  font-size: 14px;
  white-space: nowrap;
  outline: none;
  border: none;
  background-color: transparent;
  color: #d60b0b;
  position: absolute;
  left: 0;
  @media screen and (max-width: 767px) {
    display: none;
  }
`;

export const RowBody = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  align-items: center;
`;

export const OwnerName = styled.div`
  font-size: 18px;
  word-wrap: break-word;
  white-space: normal;
  width: 100%;
  text-align: start;
  @media screen and (max-width: 767px) {
    font-size: 10px;
  }
`;

export const Space = styled.div`
  width: 100%;
  text-align: start;
  padding: 0 8px;
`;

export const LoacationButton = styled.button`
  background-color: transparent;
  border: none;
  outline: none;
`;

// export const PiecesSVGStyled = styled(PiecesSVG)`
//   width: 20px;
//   @media screen and (max-width: 767px) {
//     width: 13px;
//   }
// `;

// export const AllPiecesSVGStyled = styled(PiecesSVG)`
//   margin-inline-end: 18px;
//   @media screen and (max-width: 767px) {
//     margin-inline-end: 10px;
//     width: 20px;
//     height: 20px;
//   }
// `;

export const AppliesName = styled.div`
  color: #6699ff;
  font-size: 20px;
  white-space: nowrap;
  @media screen and (max-width: 767px) {
    font-size: 13px;
  }
`;

export const TitleBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  @media screen and (max-width: 767px) {
    font-size: 13px;
    flex-wrap: wrap;
    white-space: nowrap;
  }
`;
